// 接口统一管理页面
const api = {
	apiLogin: '/xb/login', // 登录
	apiLogout: '/api/v1/logout', // 退出登录
	// home
	firstPageCount: '/sys/xb/fp/firstPageCount', // 首页做上角设备数量接口
	alarmData: '/sys/xb/fp/alarmData', // 首页右上角告警信息/告警信息表格数据
	findKzxByOrgCode: '/sys/xb/fp/findKzxByOrgCode', // 首页生产总览
	kzxData: '/sys/xb/fp/kzxData', // 首页生产总览详细数据
	findDeviceList: '/sys/xb/de/findDeviceList', // 设备总数table查询
	// 公共接口
	// findChildOrgByParentOrgId: '/sys/xb/com/findChildOrgByParentOrgId', // 获取上面的生产区域信息
	findChildOrgByParentOrgId: '/sys/xb/com/findChildOrgByParentOrgIdAndType', // 获取上面的生产区域信息

	// 生产监测
	findOperateDeviceByOrgId: '/sys/xb/psu/findOperateDeviceByOrgId', // 操作设备列表
	operateDeviceAction: '/sys/xb/psu/operateDeviceAction', //  操作设备下发相关操作接口
	findDeviceByOrgId: '/sys/xb/psu/findDeviceByOrgId', // 获取传感器下拉选
	latestDeviceData: '/sys/xb/psu/latestDeviceData', // 传感器详细数据
	getDeviceItems: '/sys/xb/psu/getDeviceItems', // 类型采集项下拉选
	findVideoByOrgId: '/sys/xb/psu/findVideoByOrgId', // 获取监控下拉选

	// 墒情监测
	soilFindDeviceByOrgId: '/sys/xb/soil/findDeviceByOrgId', // 墒情头部下拉选
	soillatestDeviceData: '/sys/xb/soil/latestDeviceData', // 墒情详情数据
	soilgetDeviceItems: '/sys/xb/soil/getDeviceItems', // 类型采集项下拉选

	// 气象监测
	qxfindDeviceByOrgId: '/sys/xb/wea/findDeviceByOrgId', // 头部下拉选
	qxlatestDeviceData: '/sys/xb/wea/latestDeviceData', // 最新详情数据
	qxgetDeviceItems: '/sys/xb/wea/getDeviceItems', // 采集项下拉选
	// 远程诊断
	findOrgVideoTree: '/sys/xb/vde/findOrgVideoTree', // 获取数据
	// 水肥监测
	sffindDeviceByOrgId: '/sys/xb/manure/findDeviceByOrgId', // 头部下拉选
	sflatestDeviceStateData: '/sys/xb/manure/latestDeviceStateData', // 指令状态数据
	sflatestDeviceActionData: '/sys/xb/manure/latestDeviceActionData', // 可执行指令数据
	sfactionOneCommand: '/sys/xb/manure/actionOneCommand', // 操作

	// 虫情监测
	cqfindDeviceByOrgId: '/sys/xb/insect/findDeviceByOrgId', // 头部下拉选
	cqfindDevicePictureByDeviceCode: '/sys/xb/insect/findDevicePictureByDeviceCode', // 图片分页组

	// 设备执行情况
	setfindDeviceNameGroup: '/sys/xb/operate/findDeviceNameGroup', // 设备名称下拉选
	setfindDeviceList: '/sys/xb/operate/findDeviceList', // 设备操作日志列表
	setfindDeviceActionCount: '/sys/xb/operate/findDeviceActionCount', // 占比分析数据

	// 告警信息
	findAlarmList: '/sys/xb/alarm/findAlarmList', // 列表数据
	findDeviceTypeItems: '/sys/xb/alarm/findDeviceNameItems', // 设备选择下拉选

	// 生产管理
	findFarmingByOrgCode: '/sys/xb/production/findFarmingByOrgCode', // 根据orgId获取分公司或网点下所有大棚组
	proFindTypeByOrgId: '/sys/xb/production/findDictFarmType', // 头部类型选择下拉选(农事类型)
	proTableList: '/sys/xb/production/findProductionList', // table列表数据
	productionSave: '/sys/xb/production/save', // 新增或修改
	productionDelete: '/sys/xb/production/delete', // 删除

	// 任务管理
	taskSetTableList: '/sys/xb/task/findTaskList', // 任务操作列表
	taskHisTableList: '/sys/xb/task/findTaskRecordList', // 历史记录列表
	taskSetFinish: '/sys/xb/task/findFinishTask', // 完成
	taskHisCancel: '/sys/xb/task/findCancelTask', // 取消

	taslSetPath: '/sys/xb/task/taskCompletedOrCanceled',
	// 日志记录
	findLoggList: '/sys/xb/log/findLogInfoList', // 日志记录列表

	videoUrl: '/hnyfkj/api/v1/getRealVideoUrl', // 视频播放地址
	ptzCtrl: '/hnyfkj/api/v1/ptzCtrl', // 视频云台控制方向
	ptzOperationCtrl: '/hnyfkj/api/v1/ptzOperationCtrl', // 视频云台控制大小

	// 综合分析
	qxAnaList: '/napi/index/weatherStationDataReport', // 气象综合table表格
	qxLineChart: '/napi/index/weatherStationDataChart', // 气象折线图数据

	// 综合分析
	// 气象
	qxSelectNew: '/sys/xb/wea/findDeviceAndORrgNameByOrgId',
	// 墒情
	sqSelectNew: '/sys/xb/soil/findDeviceAndORrgNameByOrgId',
	// 传感器
	cgqSelectNew: '/sys/xb/psu/findDeviceAndORrgNameByOrgId',

	analysisNew: '/sys/xb/wea/findDeviceAndORrgNameByOrgId',
}
export default api
